import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useMaintenanceMode = () => {
  const queryClient = useQueryClient();

  const { data: maintenanceMode, isLoading } = useQuery({
    queryKey: ['maintenance-mode'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('settings')
        .select('value')
        .eq('key', 'maintenance_mode')
        .single();

      if (error) throw error;
      const value = data?.value as { enabled?: boolean } | null;
      return value?.enabled || false;
    },
    staleTime: 5000, // Cache for 5 seconds
    refetchInterval: 10000, // Refetch every 10 seconds
  });

  const toggleMaintenance = useMutation({
    mutationFn: async (enabled: boolean) => {
      const { error } = await supabase
        .from('settings')
        .update({ 
          value: { enabled },
          updated_by: (await supabase.auth.getUser()).data.user?.id 
        })
        .eq('key', 'maintenance_mode');

      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['maintenance-mode'] });
    },
  });

  return {
    isMaintenanceMode: maintenanceMode || false,
    isLoading,
    toggleMaintenance: toggleMaintenance.mutateAsync,
    isToggling: toggleMaintenance.isPending,
  };
};
